<div class="markdown-html text-center">
	<div>{{ 'workflow.test.completed' | translate }}</div>
	<div class="centered" *ngIf="(workflowItemKey.property$ | async) as values">
		<table>
			<tbody>
			<tr>
				<td class="left-align">{{ 'word.time' | translate }}</td>
				<td class="center-align cell-padding">:</td>
				<td class="right-align">{{ values.zeit | number:'1.2-2' }} {{ 'unit.seconds.short' | translate }}</td>
			</tr>
			<tr>
				<td class="left-align">{{ 'word.error' | translate }}</td>
				<td class="center-align cell-padding">:</td>
				<td class="right-align">{{ values.fehler }}</td>
			</tr>
			</tbody>
		</table>
	</div>
</div>
